import { render, staticRenderFns } from "./channel-icon.vue?vue&type=template&id=bb67c978&scoped=true&lang=pug&"
import script from "./channel-icon.vue?vue&type=script&lang=coffee&"
export * from "./channel-icon.vue?vue&type=script&lang=coffee&"
import style0 from "./channel-icon.vue?vue&type=style&index=0&id=bb67c978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb67c978",
  null
  
)

export default component.exports